export default {
  default: () => import("/var/www/wait-mate-prod/apps/nuxt/layouts/default.vue"),
  pledge: () => import("/var/www/wait-mate-prod/apps/nuxt/layouts/pledge.vue")
}